import scrollLock from '../../functions/_scrollLock.js' // スクロールロック

const modals = document.getElementsByClassName('js-modal') // モーダル本体

/*
全体サンプル

<button type="button" class="js-modal-open" data-modal="hogeModal" data-modal-reset="1">
    モーダル展開
</button>

<dialog class="js-modal js-modal--hogeModal mdModal">
    <button type="button" class="js-modal-close mdModal__bg" data-modal-close=""></button>
    <div class="mdModal__frame">
        <button type="button" class="js-modal-close mdModal__close flex vcenter hcenter" data-modal-close="">×</button>
        <div class="mdModal__box" autofocus>
            <div class="hogeContent">
                テキスト
                <br><br><br><br><br><br><br><br><br><br>
                <br><br><br><br><br><br><br><br><br><br>
                <br><br><br><br><br><br><br><br><br><br>
                <br><br><br><br><br><br><br><br><br><br>
                <br><br><br><br><br><br><br><br><br><br>
                <br><br><br><br><br><br><br><br><br><br>
                <br><br><br><br><br><br><br><br><br><br>
                テキスト
            </div>
        </div>
    </div>
</dialog>
*/

if (modals[0]) {
  module()
}
function module() {
  //   ####  ##      ##   ####  ##  ##
  //  ##     ##      ##  ##     ## ##
  //  ##     ##      ##  ##     ####
  //  ##     ##      ##  ##     ## ##
  //   ####  ######  ##   ####  ##  ##

  //             #####   #####   #####  ##     ##
  //            ##   ##  ##  ##  ##     ####   ##
  //  ########  ##   ##  #####   #####  ##  ## ##
  //            ##   ##  ##      ##     ##    ###
  //             #####   ##      #####  ##     ##
  /*
指定のモーダルを開く
data-modal-reset="1"で展開前に全モーダルを閉じる
<button type="button" class="js-modal-open" data-modal="hogeModal" data-modal-reset="1">
    モーダル
</button>
<dialog class="js-modal js-modal--hogeModal modal">

</dialog>
*/

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-modal-open')
    if (!item) {
      return
    }
    e.preventDefault()

    if (item.dataset.modalReset === '1') {
      window.modalClose() // モーダルを閉じる
    }

    const targetName = item.dataset.modal

    window.modalOpen(targetName)
  })

  //             ####  ##       #####    ####  #####
  //            ##     ##      ##   ##  ##     ##
  //  ########  ##     ##      ##   ##   ###   #####
  //            ##     ##      ##   ##     ##  ##
  //             ####  ######   #####   ####   #####
  /*
  /*
すべてのモーダルを閉じる
data-modal-closeに指定があればそのモーダルだけ閉じる

<button type="button" class="js-modal-close" data-modal-close="">×</button>

*/
  // モーダル撤去
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-modal-close')
    if (!item) {
      return
    }
    e.preventDefault()

    const targetName = item.dataset.modalClose ? item.dataset.modalClose : ''

    window.modalClose(targetName) // モーダルを閉じる
  })
}

//   #####   #####   #####  ##     ##
//  ##   ##  ##  ##  ##     ####   ##
//  ##   ##  #####   #####  ##  ## ##
//  ##   ##  ##      ##     ##    ###
//   #####   ##      #####  ##     ##
/*
指定のモーダルを開く
window.modalOpen('hogeModal')
*/
window.modalOpen = function (targetName) {
  const openModal = document.querySelector('.js-modal--' + targetName)
  openModal.classList.add('active')
  // openModal.showModal()
  scrollLock('body', '.js-modal') // ページスクロール固定判定
}

//   ####  ##       #####    ####  #####
//  ##     ##      ##   ##  ##     ##
//  ##     ##      ##   ##   ###   #####
//  ##     ##      ##   ##     ##  ##
//   ####  ######   #####   ####   #####
/*
すべてのモーダルを消す
targetName指定でそのモーダルだけ消す
window.modalClose()
window.modalClose('hogeModal')
*/
window.modalClose = function (targetName = '') {
  if (targetName !== '') {
    const closeModal = document.querySelector('.js-modal--' + targetName)
    if (closeModal) {
      closeModal.classList.remove('active')
      // closeModal.close()
    }
  } else {
    // すべてのモーダルを消す
    for (const modal of modals) {
      modal.classList.remove('active')
      // modal.close()
    }
  }

  scrollLock('body', '.js-modal') // ページスクロール固定判定
}
